import { gql } from 'graphql-request'
import { contentFragments } from '../content/all-content-list'
import { defaultsQuery } from '../globals/defaults'
import { CollectionType } from 'app/queries/collections/collection-fragment'

export const createSearchQuery = () => gql`
  ${contentFragments}

  query getAllContent(
    $search: String
    $collection: String
    $category: String
    $year: String
    $contentTier: String
    $contentType: String
    $tag: String
    $idsToRemove: [String]
    $isLatest: Boolean

    $sort: String

    $page: Int
    $limit: Int
  ) {
    search (
      search: $search
      collection: $collection
      category: $category
      year: $year
      contentTier: $contentTier
      contentType: $contentType
      tag: $tag
      idsToRemove: $idsToRemove
      isLatest: $isLatest

      sort: $sort
      page: $page
      limit: $limit
    ) {
      totalDocs
      page
      docs {
        ...content
      }
    }

    ${defaultsQuery}
  }
`

export const typeToVariable = (type?: CollectionType, id?: string) => {
  if (type === 'MemberTier') {
    return { contentTier: id || '1' }
  }

  if (!type || !id) {
    return {}
  }

  return { [type.toLowerCase()]: id }
}
